// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"J_TheComp__C6AO8"};